export default __webpack_public_path__ + "static/media/elaichi-tea.2415ce2c.png";